import { z } from 'zod';
import { queuePoolSchema, queueStatsSchema } from '../queueShared';

export const socialJobInfoSchema = z.object({
  id: z.number(),
  socialVideoId: z.number(),
  challengeId: z.number(),
  version: z.number(),
  slug: z.string(),
  outputKey: z.string(),
  status: z.enum(['pending', 'rendering', 'completed', 'failed']),
  error: z.string().nullable(),
  fileSizeKb: z.number().nullable(),
  durationMs: z.number().nullable(),
  createdAt: z.string(),
  startedAt: z.string().nullish(),
  completedAt: z.string().nullish(),
});

export const fetchSocialJobsResponseSchema = z.object({
  jobs: z.array(socialJobInfoSchema),
  pool: queuePoolSchema.optional(),
  stats: queueStatsSchema.optional(),
});

export type ISocialJobInfo = z.infer<typeof socialJobInfoSchema>;
export type IFetchSocialJobsResponse = z.infer<typeof fetchSocialJobsResponseSchema>;
